import { RadixSlider } from '../../../../components/ui/slider';

export interface SliderProps extends React.ComponentProps<typeof RadixSlider> {
  /** 방향 */
  direction?: 'horizontal' | 'vertical';
  /** 크기 */
  size?: 'sm' | 'md';
  /** hover 시에만 Thumb 표시 여부 */
  showThumbOnHover?: boolean;
  /** 툴팁 렌더링 함수 (각 thumb별로 커스텀 렌더링 가능) */
  renderTooltip?: (value: number, index: number) => React.ReactNode;
}

export default function Slider({
  direction = 'horizontal',
  size = 'md',
  ...props
}: SliderProps) {
  return (
    <RadixSlider
      {...props}
      orientation={direction === 'horizontal' ? 'horizontal' : 'vertical'}
      size={size}
    />
  );
}
